module.exports = __webpack_public_path__ + "static/media/icon-woman.1966afed.svg";